import {Expressions} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {
  isOptimizationBaseElement,
  isOptimizationTreatmentElement,
} from '@packages/utilities/platform';
import {VARIATION_ID_PATH, EXPERIENCES_BY_VARIATION_ID} from './constants';

export function isMatchingVariation(
  element: ExpressionElement,
  variationId: string | null
): boolean {
  if (!variationId) {
    return isOptimizationBaseElement(element);
  }

  if (isOptimizationTreatmentElement(element)) {
    return (
      Expressions.getElementDataAt(element, VARIATION_ID_PATH, 'Text', '') ===
      variationId
    );
  }

  if (isOptimizationBaseElement(element)) {
    return Boolean(
      Expressions.getIn(Expressions.getElementData(element), [
        ...EXPERIENCES_BY_VARIATION_ID,
        {in: 'Record', at: variationId},
      ])
    );
  }

  return false;
}
